// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store'
import i18n from './lang/lang'
import Vuetify from 'vuetify'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueMeta from 'vue-meta'

import App from './App.vue'
import router from './router'
import 'babel-polyfill'
import VueSocketIO from 'vue-socket.io'

import colors from 'vuetify/es5/util/colors'
import VueToastr from '@deveodk/vue-toastr'
// You need a specific loader for CSS files like https://github.com/webpack/css-loader
// If you would like custom styling of the toastr the css file can be replaced
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'
let SocialSharing = require('vue-social-sharing')
Vue.use(SocialSharing)
Vue.use(VueToastr, {
  defaultPosition: 'toast-bottom-left',
  defaultType: 'info',
  defaultTimeout: 3000
})
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})
Vue.use(Vuetify, {
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  },
  theme: {
    primary: '#5a65db',
    secondary: colors.grey.darken1,
    accent: colors.shades.black,
    error: '#ff1744'
  }
})
Vue.use(VueAwesomeSwiper)
const moment = require('moment')
require('moment/locale/hy-am')
Vue.use(require('vue-moment'), {
  moment
})
Vue.use(new VueSocketIO({
  debug: process.env.SOCKET_DEBUG,
  connection: process.env.ROOT_API,
  vuex: {
    store,
    actionPrefix: 'SOCKET_',
    mutationPrefix: 'SOCKET_'
  }
}))
Vue.config.productionTip = false
/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  store,
  router,
  i18n,
  components: { App },
  template: '<App/>'
})
export default app



// WEBPACK FOOTER //
// ./src/main.js